import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b8ef89b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breadcrumb" }

import { BreadcrumbRoute } from '@/types/breadcrumb-route';

  export interface IProps {
    routes: BreadcrumbRoute[]
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    routes: null
  },
  setup(__props: any) {

  


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("ol", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.routes, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass([{ active: index === __props.routes.length - 1 }, "breadcrumb-item"])
        }, [
          (index === __props.routes.length - 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(item.name), 1)
              ], 64))
            : (_openBlock(), _createBlock(_resolveDynamicComponent(item.to ? 'router-link' : 'span'), {
                key: 1,
                to: item.to
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
        ], 2))
      }), 128))
    ])
  ]))
}
}

})